import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  RedditShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  EmailShareButton,
  FacebookIcon,
  XIcon,
  LinkedinIcon,
  RedditIcon,
  WhatsappIcon,
  TelegramIcon,
  EmailIcon,
} from 'react-share';
import './SocialShare.css';

const SocialShare = ({ 
  url = window.location.href,
  title = 'File Convert Hub - Free Online File Converter',
  description = 'Convert your files easily and efficiently in your browser. No upload required!'
}) => {
  const iconSize = 32;
  const iconBorderRadius = 8;

  return (
    <div className="social-share-inline">
      <FacebookShareButton
        url={url}
        hashtag="#fileconverter"
        className="social-icon-btn"
      >
        <FacebookIcon size={iconSize} borderRadius={iconBorderRadius} />
      </FacebookShareButton>

      <TwitterShareButton
        url={url}
        title={title}
        hashtags={['fileconverter', 'pdfconverter']}
        className="social-icon-btn"
      >
        <XIcon size={iconSize} borderRadius={iconBorderRadius} />
      </TwitterShareButton>

      <LinkedinShareButton
        url={url}
        title={title}
        summary={description}
        source="File Convert Hub"
        className="social-icon-btn"
      >
        <LinkedinIcon size={iconSize} borderRadius={iconBorderRadius} />
      </LinkedinShareButton>

      <RedditShareButton
        url={url}
        title={title}
        className="social-icon-btn"
      >
        <RedditIcon size={iconSize} borderRadius={iconBorderRadius} />
      </RedditShareButton>

      <WhatsappShareButton
        url={url}
        title={title}
        separator=" - "
        className="social-icon-btn"
      >
        <WhatsappIcon size={iconSize} borderRadius={iconBorderRadius} />
      </WhatsappShareButton>

      <TelegramShareButton
        url={url}
        title={title}
        className="social-icon-btn"
      >
        <TelegramIcon size={iconSize} borderRadius={iconBorderRadius} />
      </TelegramShareButton>

      <EmailShareButton
        url={url}
        subject={title}
        body={`${description}\n\n`}
        className="social-icon-btn"
      >
        <EmailIcon size={iconSize} borderRadius={iconBorderRadius} />
      </EmailShareButton>
    </div>
  );
};

export default SocialShare;

